import {ListFeedback} from './list-feedback';

export default ListFeedback;